import React from "react";
import { motion } from "framer-motion";
import "./RnR.css";

import img1 from "../../assets/RnR/1.webp";
import img2 from "../../assets/RnR/2.webp";
import img3 from "../../assets/RnR/3.webp";
import img4 from "../../assets/RnR/4.webp";
import img5 from "../../assets/RnR/5.webp";
import img6 from "../../assets/RnR/6.webp";
import img7 from "../../assets/RnR/7.webp";
import img8 from "../../assets/RnR/8.webp";
import img9 from "../../assets/RnR/9.webp";
import img10 from "../../assets/RnR/10.webp";
import img11 from "../../assets/RnR/11.webp";
import img12 from "../../assets/RnR/12.webp";
import img13 from "../../assets/RnR/13.webp";

const images = [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img9,
  img10,
  img11,
  img12,
  img13
];

function Rewards() {
  return (
    <div className="rewards-container">
      <h1 className="rewards-title">Our Rewards</h1>
      <div className="rewards-list">
        {images.map((img, index) => (
          <motion.div
            key={index}
            className="reward-item"
            initial={{ 
              x: index % 2 === 0 ? -150 : 150, 
              opacity: 0 
            }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: false, amount: 0.3 }}
          >
            <img src={img} alt={`Reward ${index + 1}`} />
          </motion.div>
        ))}
      </div>
    </div>
  );
}

export default Rewards;
